import * as React from "react";
import {Link} from "react-router";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

export interface CardProps extends React.Props<CardProps> {
    isParentCard: boolean;
    link?: string;
}

export interface CardHeaderProps extends React.Props<CardHeader> {
    title: string;
    titleClassName?: string;
    subtitle?: string;
    subtitleClassName?: string;
    button?: React.ReactElement<any>;
    location?: string;
    link?: string;
}

export interface CardBodyProps extends React.Props<CardHeader> {

}

export interface CardActionsProps extends React.Props<CardActions> {
    link?: string;
}

export class Card extends React.Component<CardProps, any> {
    render() {
        let link = null;
        if (this.props.link) {
            link = <a href={this.props.link} className="overlay-link" />
        }

        return (
            <div className={this.props.isParentCard ? 'card card-multiple' : 'card'}>
                {link}
                {this.props.children}
            </div>
        );
    }
}

export class CardHeader extends React.Component<CardHeaderProps, any> {
    private buildClassName(standard, append) {
        if (append) standard += ' ' + append;
        return standard;
    }
    render() {
        let titleClasses = this.props.titleClassName;
        let subtitleClasses = this.buildClassName('card-subtitle',
                                this.props.subtitleClassName);
        let subtitleLocationClasses = "";
        if (this.props.location){
            subtitleLocationClasses = this.buildClassName('card-subtitle-location',
                this.props.subtitleClassName);
        }
        let link = null;
        if (this.props.link) {
            link = <a href={this.props.link} className="overlay-link" />
        }
        return (
            <div className="card-header">
                {link}
                {this.props.button}
                <h3 className={titleClasses}>{this.props.title}</h3>
                {this.props.subtitle &&
                    <span className={subtitleClasses}>{this.props.subtitle}</span>
                }
                {this.props.location &&
                    <span className={subtitleLocationClasses}>{this.props.location}</span>
                }
            </div>
        );
    }
}

export class CardBody extends React.Component<CardBodyProps, any> {
    render() {
        return (
            <div className="card-body">
                {this.props.children}
            </div>
        );
    }
}

export class CardActions extends React.Component<CardActionsProps, any> {
    render() {
        let link = null;
        if (this.props.link) {
            link = <a href={this.props.link} className="overlay-link" />
        }
        return (
            <div className="card-actions">
                {link}
                {this.props.children}
            </div>
        );
    }
}
